export default __webpack_public_path__ + "static/media/vim.b087bd16.svg";